import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import Topbar from '../layouts/Topbar';
import Sidebar from '../layouts/Sidebar';
import '../../HR Manager/screens/EmployeeGoals.css';
import { FaEdit, FaTrash, FaEye, FaSpinner } from 'react-icons/fa';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { toast } from 'react-toastify';
import axios from 'axios';
import API_BASE_URL from '../../../config/api';

const HODGoals = () => {
    const baseUrl = API_BASE_URL;
    const navigate = useNavigate();
    const [goals, setGoals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedActivities, setExpandedActivities] = useState({});
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedGoal, setSelectedGoal] = useState(null);
    const [progressHistory, setProgressHistory] = useState([]);
    const [progressLoading, setProgressLoading] = useState(false);
    const [progressError, setProgressError] = useState(null);
    const [progressModalOpen, setProgressModalOpen] = useState(false);
    const [progressForm, setProgressForm] = useState({ status: 'in_progress', comments: '', score: '', file: null });
    const [progressSubmitting, setProgressSubmitting] = useState(false);
    const [progressSubmitError, setProgressSubmitError] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editForm, setEditForm] = useState({
        key_result_area: null,
        activity: '',
        metric: '',
        stakeholder: '',
        performance_standard: null,
        quarter: null,
        year: new Date().getFullYear(),
        week: '',
        month: null
    });
    // Year filtering
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [availableYears, setAvailableYears] = useState([]);
    const [selectedQuarter, setSelectedQuarter] = useState('');
    const [editLoading, setEditLoading] = useState(false);
    const [editError, setEditError] = useState(null);
    const [kras, setKras] = useState([]);
    const [fetchingKRAs, setFetchingKRAs] = useState(false);
    const quarterOptions = [
        { value: 'Q1', label: 'Quarter 1' },
        { value: 'Q2', label: 'Quarter 2' },
        { value: 'Q3', label: 'Quarter 3' },
        { value: 'Q4', label: 'Quarter 4' },
        { value: 'Quarterly', label: 'Quarterly' },
        { value: 'Weekly', label: 'Weekly' },
        { value: 'Bi-Weekly', label: 'Bi-Weekly' },
        { value: 'Monthly', label: 'Monthly' },
        { value: 'Semi-Annually', label: 'Semi-Annually' },
        { value: 'Annually', label: 'Annually' },
      ]

    const monthOptions = [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' },
    ];

    const performanceStandardOptions = [
        { value: 'Monthly', label: 'MONTHLY' },
        { value: 'Quarterly', label: 'QUARTELY' },
        { value: 'Always', label: 'ALWAYS' },
        { value: 'As and when necessary', label: 'AS AND WHEN NECESSARY' },
        { value: 'As and when required', label: 'AS AND WHEN REQUIRED' },
        { value: 'Daily', label: 'DAILY' },
        { value: 'Annually in line with policies and procedures', label: 'ANNUALLY IN LINE WITH POLICIES AND PROCEDURES' },
        { value: 'Quarterly accurate records daily', label: 'QUARTELY ACCURATE RECORDS DAILY' }
    ];

    const toggleActivityExpansion = (goalId) => {
        setExpandedActivities(prev => ({
            ...prev,
            [goalId]: !prev[goalId]
        }));
    };

    const fetchProgressHistory = async (goalId) => {
        setProgressLoading(true);
        setProgressError(null);
        try {
            const token = Cookies.get('token');
            const response = await axios.get(`${baseUrl}/api/goals/${goalId}/progress/`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            const data = response.data;
            setProgressHistory(Array.isArray(data) ? data : (data.results || []));
        } catch (err) {
            setProgressError(err.message || 'Could not load progress history');
        } finally {
            setProgressLoading(false);
        }
    };

    const handleViewGoal = (goal) => {
        setSelectedGoal(goal);
        setModalOpen(true);
        fetchProgressHistory(goal.id);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedGoal(null);
    };

    const openProgressModal = () => {
        setProgressForm({ status: 'in_progress', comments: '', score: '', file: null });
        setProgressSubmitError(null);
        setProgressModalOpen(true);
    };
    const closeProgressModal = () => {
        setProgressModalOpen(false);
    };
    const handleProgressFormChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'file') {
            setProgressForm(prev => ({ ...prev, file: files && files[0] ? files[0] : null }));
            return;
        }
        setProgressForm(prev => ({ ...prev, [name]: value }));
    };
    const handleProgressSubmit = async (e) => {
        e.preventDefault();
        setProgressSubmitting(true);
        setProgressSubmitError(null);
        try {
            const token = Cookies.get('token');
            await axios.post(`${baseUrl}/api/goals/${selectedGoal.id}/progress/`,
                { status: progressForm.status, comments: progressForm.comments, score: progressForm.score },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (progressForm.status === 'completed') {
                if (!progressForm.file) {
                    throw new Error('Supporting document is required when status is completed.');
                }
                const filePayload = new FormData();
                filePayload.append('performance_goal', selectedGoal.id);
                filePayload.append('document', progressForm.file);

                await axios.post(`${baseUrl}/api/goal-documents/`, filePayload, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });
            }

            setProgressModalOpen(false);
            await fetchProgressHistory(selectedGoal.id);
            // Fetch updated goal and update in goals state
            const updatedGoalRes = await axios.get(`${baseUrl}/api/goals/${selectedGoal.id}/`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            const updatedGoal = updatedGoalRes.data;
            setGoals(prevGoals => prevGoals.map(g => (g.id === updatedGoal.id ? updatedGoal : g)));
            setSelectedGoal(updatedGoal);
        } catch (err) {
            setProgressSubmitError(err.message || 'Could not update progress');
        } finally {
            setProgressSubmitting(false);
        }
    };

    const handleDeleteGoal = async (goal) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'This will permanently delete the goal.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        });
        if (result.isConfirmed) {
            try {
                const token = Cookies.get('token');
                await axios.delete(`${baseUrl}/api/goals/${goal.id}/`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                setGoals(prevGoals => prevGoals.filter(g => g.id !== goal.id));
                Swal.fire('Deleted!', 'The goal has been deleted.', 'success');
            } catch (err) {
                Swal.fire('Error', err.message || 'Failed to delete goal', 'error');
            }
        }
    };

    // Fetch KRAs for select
    useEffect(() => {
        const fetchKRAs = async () => {
            setFetchingKRAs(true);
            try {
                const token = Cookies.get('token');
                const response = await axios.get(`${baseUrl}/api/key-result-areas/`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                setKras(response.data);
            } catch (err) {
                // Optionally handle error
            } finally {
                setFetchingKRAs(false);
            }
        };
        fetchKRAs();
    }, []);

    const kraOptions = kras.map(kra => ({ value: kra.id, label: kra.name }));

    const openEditModal = (goal) => {
        let kraOption = null;
        if (goal.key_result_area) {
            if (typeof goal.key_result_area === 'object' && goal.key_result_area !== null && 'id' in goal.key_result_area) {
                kraOption = kraOptions.find(k => k.value === goal.key_result_area.id) || null;
            } else if (typeof goal.key_result_area === 'number' || typeof goal.key_result_area === 'string') {
                kraOption = kraOptions.find(k => k.value === goal.key_result_area) || null;
            }
        }
        let quarterOption = null;
        if (goal.quarter) {
            quarterOption = quarterOptions.find(q => q.value === goal.quarter) || null;
        }

        let performanceStandardOption = null;
        if (goal.performance_standard) {
            performanceStandardOption = performanceStandardOptions.find(p => p.value === goal.performance_standard) || null;
        }

        let monthOption = null;
        if (goal.month) {
            monthOption = monthOptions.find(m => m.value === goal.month) || null;
        }

        setEditForm({
            key_result_area: kraOption,
            activity: goal.activity || '',
            metric: goal.metric || '',
            stakeholder: goal.stakeholder || '',
            performance_standard: performanceStandardOption,
            quarter: quarterOption,
            year: goal.year || new Date().getFullYear(),
            week: goal.week || '',
            month: monthOption,
        });
        setEditError(null);
        setSelectedGoal(goal);
        setEditModalOpen(true);
    };
    const closeEditModal = () => {
        setEditModalOpen(false);
    };

    const handleOverlayClick = (e, closeFunc) => {
        if (e.target.classList.contains('modal-overlay')) {
            closeFunc();
        }
    };
    const handleEditFormChange = (e) => {
        setEditForm({ ...editForm, [e.target.name]: e.target.value });
    };
    const handleEditSelectChange = (selected, { name }) => {
        setEditForm({ ...editForm, [name]: selected });
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setEditLoading(true);
        setEditError(null);
        try {
            const token = Cookies.get('token');
            const response = await axios.put(`${baseUrl}/api/goals/${selectedGoal.id}/`, {
                key_result_area_id: editForm.key_result_area ? editForm.key_result_area.value : null,
                activity: editForm.activity,
                metric: parseInt(editForm.metric),
                stakeholder: editForm.stakeholder,
                performance_standard: editForm.performance_standard ? editForm.performance_standard.value : null,
                quarter: editForm.quarter ? editForm.quarter.value : null,
                week: editForm.quarter?.value === 'Weekly' ? parseInt(editForm.week) : null,
                month: editForm.quarter?.value === 'Monthly' ? (editForm.month ? parseInt(editForm.month.value) : null) : null,
                year: editForm.year || new Date().getFullYear(),
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            const updatedGoal = response.data;
            setGoals(prevGoals => prevGoals.map(g => (g.id === updatedGoal.id ? updatedGoal : g)));
            setSelectedGoal(updatedGoal);
            setEditModalOpen(false);
            toast.success('Goal updated successfully!');
        } catch (err) {
            setEditError(err.message || 'Could not update goal');
        } finally {
            setEditLoading(false);
        }
    };

    useEffect(() => {
        // Fetch user profile data
        const fetchProfile = async () => {
            setLoading(true);
            setError(null);
            try {
                const token = Cookies.get('token');
                const response = await axios.get(`${baseUrl}/api/users/me`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                setGoals(response?.data?.employee?.goals);
            } catch (err) {
                setError(err.response?.data?.message || err.message || 'Failed to fetch profile');
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, []);

    // Extract unique years from goals
    useEffect(() => {
        if (goals && goals.length > 0) {
            const uniqueYears = [...new Set(goals
                .map(goal => goal.year)
                .filter(year => year !== null && year !== undefined)
            )].sort((a, b) => b - a); // Sort descending (newest first)

            if (uniqueYears.length > 0) {
                setAvailableYears(uniqueYears);
            }
        } else {
            setAvailableYears([]);
        }
    }, [goals]);

    return (
        <>
            {/* Beat Loader CSS */}
            <style>{`
                .beat-loader {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 8px;
                    height: 48px;
                }
                .beat-loader-dot {
                    width: 12px;
                    height: 12px;
                    background: #4f46e5;
                    border-radius: 50%;
                    animation: beat 0.7s infinite alternate;
                }
                .beat-loader-dot:nth-child(2) {
                    animation-delay: 0.2s;
                }
                .beat-loader-dot:nth-child(3) {
                    animation-delay: 0.4s;
                }
                @keyframes beat {
                    to {
                        transform: scale(1.4);
                        opacity: 0.5;
                    }
                }
            `}</style>
            <Topbar />
            <Sidebar />
            <div
                className="employee-goals-container"
            >
                <div className="hr-content-wrapper" style={{ maxWidth: 1000, margin: '0 auto', padding: 24 }}>
                    <div style={{ height: '40px', width: '90%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className="page-header">
                        <div style={{ color: '#fff' }} className="page-titl">
                            <h3 style={{ paddingTop: '-30px', color: 'fff' }}>My Key Performance Indicators</h3>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, zIndex: '1201', position: 'relative' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <label style={{ fontSize: 15, color: '#fff' }}>Year</label>
                                <select
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                                    style={{
                                        padding: '6px 10px',
                                        border: '1px solid #cbd5e1',
                                        borderRadius: 6,
                                        background: '#fff',
                                        color: '#0f172a',
                                        fontSize: 14,
                                        cursor: 'pointer'
                                    }}
                                    title="Filter by year"
                                >
                                    {(availableYears.length ? availableYears : [selectedYear])
                                        .sort((a, b) => a - b)
                                        .map(y => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                </select>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <label style={{ fontSize: 15, color: '#fff' }}>Quarter</label>
                                <select
                                    value={selectedQuarter}
                                    onChange={(e) => setSelectedQuarter(e.target.value)}
                                    style={{
                                        padding: '6px 10px',
                                        border: '1px solid #cbd5e1',
                                        borderRadius: 6,
                                        background: '#fff',
                                        color: '#0f172a',
                                        fontSize: 14,
                                        cursor: 'pointer'
                                    }}
                                    title="Filter by quarter"
                                >
                                    <option value="">All</option>
                                    <option value="Q1">Q1</option>
                                    <option value="Q2">Q2</option>
                                    <option value="Q3">Q3</option>
                                    <option value="Q4">Q4</option>
                                    <option value="Quarterly">Quarterly</option>
                                    <option value="Weekly">Weekly</option>
                                    <option value="Bi-Weekly">Bi-Weekly</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Semi-Annually">Semi-Annually</option>
                                    <option value="Annually">Annually</option>
                                </select>
                            </div>
                            <button
                                className="add-goal-btn"
                                style={{
                                    background: '#4F46E5',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: 8,
                                    padding: '8px 22px',
                                    fontWeight: 600,
                                    fontSize: 15,
                                    cursor: 'pointer',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                                    transition: 'background 0.2s',
                                    marginLeft: 16
                                }}
                                onClick={() => navigate('/hod/create-goal')}
                            >
                                + Add KPI
                            </button>
                        </div>
                    </div>
                    {/* Filters integrated into header (Year, Quarter) */}
                    {loading ? (
                        <div className="loading-state">
                            <div className="beat-loader">
                                <div className="beat-loader-dot"></div>
                                <div className="beat-loader-dot"></div>
                                <div className="beat-loader-dot"></div>
                            </div>
                        </div>
                    ) : error ? (
                        <div className="error-state">{error}</div>
                    ) : goals.length === 0 ? (
                        <div className="empty-row">No KPIs found.</div>
                    ) : (
                        <div className="goals-table-wrapper">
                            <table className="goals-table">
                                <thead>
                                    <tr>
                                        <th>Activity</th>
                                        <th>Stakeholder</th>
                                        <th>KPI Metric</th>
                                        <th>Status</th>
                                        <th>Period</th>
                                        <th>RAG</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(() => {
                                        // Apply existing filters
                                        const filteredGoals = goals
                                            .filter(g => (g.year !== undefined && g.year !== null) ? g.year === selectedYear : true)
                                            .filter(goal => !selectedQuarter || goal.quarter === selectedQuarter);

                                        // Group by KRA
                                        const groupedByKra = filteredGoals.reduce((acc, goal) => {
                                            const kraName =
                                                (goal.key_result_area && typeof goal.key_result_area === 'object'
                                                    ? goal.key_result_area.name
                                                    : goal.key_result_area) || 'Uncategorized';
                                            if (!acc[kraName]) acc[kraName] = [];
                                            acc[kraName].push(goal);
                                            return acc;
                                        }, {});

                                        // If no goals after filtering, show message
                                        if (filteredGoals.length === 0) {
                                            return (
                                                <tr>
                                                    <td colSpan={7} className="empty-row">
                                                        No KPIs found for the selected filters.
                                                    </td>
                                                </tr>
                                            );
                                        }

                                        return Object.entries(groupedByKra).map(([kraName, kraGoals]) => (
                                            <React.Fragment key={kraName}>
                                                <tr className="kra-group-row">
                                                    <td colSpan={7} style={{ fontWeight: 700, background: '#f1f5f9' }}>
                                                        {kraName}{' '}
                                                        <span style={{ fontWeight: 800, color: '#475569' }}>
                                                            (KRA Weight: {kraGoals?.[0]?.key_result_area?.percentage ??
                                                                kraGoals?.[0]?.kra?.percentage ??
                                                                kraGoals?.[0]?.percentage ?? 0}%)
                                                        </span>
                                                    </td>
                                                </tr>
                                                {kraGoals.map((goal, idx) => (
                                                    <tr key={goal.id || `${kraName}-${idx}`}>
                                                        <td>
                                                            {(() => {
                                                                let activityStr = typeof goal.activity === 'object' && goal.activity !== null
                                                                    ? JSON.stringify(goal.activity)
                                                                    : (goal.activity || '[No Activity]');
                                                                const expandKey = goal.id || `${kraName}-${idx}`;
                                                                const isExpanded = expandedActivities[expandKey];
                                                                if (activityStr.length > 25) {
                                                                    return (
                                                                        <>
                                                                            {isExpanded ? activityStr : activityStr.slice(0, 25) + '...'}
                                                                            <span
                                                                                className="expand-dots"
                                                                                style={{ color: '#667eea', cursor: 'pointer', marginLeft: 4, fontWeight: 600 }}
                                                                                onClick={() => toggleActivityExpansion(expandKey)}
                                                                            >
                                                                                {isExpanded ? ' [less]' : ' [more]'}
                                                                            </span>
                                                                        </>
                                                                    );
                                                                }
                                                                return activityStr;
                                                            })()}
                                                        </td>
                                                        <td>{goal.stakeholder}</td>
                                                        <td>
                                                            <span>{goal.metric}%</span>
                                                        </td>
                                                        <td>
                                                            <span className={`status-badge status-${goal.approval_status?.toLowerCase() || 'unknown'}`}>
                                                                {goal.approval_status === 'pending' && <FaSpinner className="pending-spinner" />}
                                                                {goal.approval_status || 'Unknown'}
                                                            </span>
                                                        </td>
                                                        <td>{goal.quarter}</td>
                                                        <td>
                                                            <div className="rag-bar-bg">
                                                                <div
                                                                    className="rag-bar-fill"
                                                                    style={{ backgroundColor: goal.progress_indicator || '#e5e7eb', width: '100%' }}
                                                                >
                                                                    <span className="rag-bar-label">{goal.rag_color || ''}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="goal-actions">
                                                                {(goal.approval_status === 'pending' || goal.approval_status === 'rejected') && (
                                                                    <>
                                                                        <button className="action-button edit-button" title="Edit" onClick={() => openEditModal(goal)}>
                                                                            <FaEdit />
                                                                        </button>
                                                                        <button className="action-button delete-button" title="Delete" onClick={() => handleDeleteGoal(goal)}>
                                                                            <FaTrash />
                                                                        </button>
                                                                        <button className="action-button view-button" title="View" onClick={() => handleViewGoal(goal)}>
                                                                            <FaEye />
                                                                        </button>
                                                                    </>
                                                                )}
                                                                {goal.approval_status === 'approved' && (
                                                                    <button className="action-button view-button" title="View" onClick={() => handleViewGoal(goal)}>
                                                                        <FaEye />
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        ));
                                    })()}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
            {/* Goal Details Modal */}
            {modalOpen && selectedGoal && (
                <div className="modal-overlay">
                    <div className="modal-content-employee-goal">
                        <div className="modal-header">
                            <h2 style={{color: '#fff'}}>KPI Details</h2>
                        </div>
                        <div className="modal-body">
                            <div className="goal-details-grid">
                                <div className="goal-detail-row">
                                    <label>Key Result Area:</label>
                                    <span>{selectedGoal.key_result_area?.name || selectedGoal.key_result_area || '[No KRA]'}</span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Key Result Area Weight:</label>
                                    <span>{selectedGoal.key_result_area?.percentage || selectedGoal.percentage}%</span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Activity:</label>
                                    <span>{typeof selectedGoal.activity === 'object' && selectedGoal.activity !== null ? JSON.stringify(selectedGoal.activity) : (selectedGoal.activity || '[No Activity]')}</span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>KPI Metric:</label>
                                    <span>{selectedGoal.metric}%</span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Stakeholder:</label>
                                    <span>{selectedGoal.stakeholder}</span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Period:</label>
                                    <span>{selectedGoal.quarter}</span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>RAG Color:</label>
                                    <div className="progress-indicator-display" style={{ backgroundColor: selectedGoal.progress_indicator || '#e5e7eb', width: '100%' }}>
                                        {selectedGoal.rag_color || ''}
                                    </div>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Status:</label>
                                    <span>
                                        {selectedGoal.status
                                            ? selectedGoal.status.charAt(0).toUpperCase() + selectedGoal.status.slice(1).replace(/_/g, ' ')
                                            : 'N/A'}
                                    </span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Approval Status:</label>
                                    <span className={`status-badge status-${selectedGoal.approval_status?.toLowerCase() || 'unknown'}`}>
                                        {selectedGoal.approval_status ? selectedGoal.approval_status.charAt(0).toUpperCase() + selectedGoal.approval_status.slice(1) : 'N/A'}
                                    </span>
                                </div>
                                <div className="goal-detail-row">
                                    <label>Due Date:</label>
                                    <span>
                                        {selectedGoal.completion_date
                                            ? new Date(selectedGoal.completion_date).toLocaleDateString('en-GB')
                                            : 'N/A'}
                                    </span>
                                </div>
                                {selectedGoal.approval_status === 'rejected' && selectedGoal.rejected_reason && (
                                    <div className="goal-detail-row full-width">
                                        <label>Rejection Reason:</label>
                                        <span className="rejection-reason">{selectedGoal.rejected_reason}</span>
                                    </div>
                                )}
                            </div>
                            {selectedGoal.approval_status === 'approved' && (
                                <div style={{ margin: '32px 0 0 0' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                        <h3 style={{ fontWeight: 700, fontSize: 20, color: '#1e293b', margin: 0 }}>Progress History</h3>
                                        <button
                                            className="submit-button"
                                            style={{
                                                padding: '8px 20px',
                                                fontSize: 15,
                                                borderRadius: 8,
                                                fontWeight: 600,
                                                background: selectedGoal.status === 'completed'
                                                    ? 'linear-gradient(135deg,#d1d5db 0%, #a1a1aa 100%)'
                                                    : 'linear-gradient(135deg,rgb(122, 195, 231) 0%, #4f46e5 100%)',
                                                color: '#fff',
                                                border: 'none',
                                                boxShadow: '0 2px 8px rgba(34,197,94,0.08)',
                                                width: '40%',
                                                cursor: selectedGoal.status === 'completed' ? 'not-allowed' : 'pointer',
                                                opacity: selectedGoal.status === 'completed' ? 0.7 : 1,
                                            }}
                                            onClick={selectedGoal.status === 'completed' ? undefined : openProgressModal}
                                            disabled={selectedGoal.status === 'completed'}
                                        >
                                            Update Progress
                                        </button>
                                    </div>
                                    <div className="goals-table-wrapper" style={{ boxShadow: 'none', border: '1px solid #e2e8f0', padding: 0 }}>
                                        <table className="goals-table">
                                            <thead>
                                                <tr>
                                                    <th>Comment</th>
                                                    <th>Status</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedGoal.progress_history.length === 0 ? (
                                                    <tr><td colSpan={2} className="empty-row">No progress history.</td></tr>
                                                ) : (
                                                    selectedGoal.progress_history.map((ph, i) => (
                                                        <tr key={ph.id || i}>
                                                            <td>{ph.comments}</td>
                                                            <td style={{ textTransform: 'capitalize' }}>{ph.status}</td>
                                                            <td>{ph.reported_at ? new Date(ph.reported_at).toLocaleString('en-US', { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }) : '-'}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button onClick={closeModal} className="modal-close-button">Close</button>
                        </div>
                    </div>
                </div>
            )}
            {/* Progress Update Modal */}
            {progressModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content-employee-goal" style={{ maxWidth: 600 }}>
                        <div className="modal-header">
                            <h2 style={{color: '#fff'}}>Update Progress</h2>
                        </div>
                        <form onSubmit={handleProgressSubmit} className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                            <div className="goal-detail-row">
                                <label htmlFor="progress-status">Status:</label>
                                <br />
                                <select
                                    id="progress-status"
                                    name="status"
                                    value={progressForm.status}
                                    onChange={handleProgressFormChange}
                                    className="form-input"
                                    style={{ minWidth: 170 }}
                                    required
                                >
                                    <option value="in_progress">In Progress</option>
                                    <option value="completed">Completed</option>
                                </select>
                            </div>
                            {/* Score input if status is completed */}
                            {progressForm.status === 'completed' && (
                                <div className="goal-detail-row">
                                    <label htmlFor="progress-score">Score:</label>
                                    <br />
                                    <input
                                        id="progress-score"
                                        name="score"
                                        type="number"
                                        min={0}
                                        max={selectedGoal.metric}
                                        value={progressForm.score || ''}
                                        onChange={handleProgressFormChange}
                                        className="form-input"
                                        style={{ minWidth: 100 }}
                                        required
                                        placeholder={`Max: ${selectedGoal.metric}`}
                                    />
                                    {progressForm.score > selectedGoal.metric && (
                                        <div style={{ color: '#ef4444', fontSize: 13, marginTop: 4 }}>
                                            Score cannot be greater than the goal metric ({selectedGoal.metric}).
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className="goal-detail-row">
                                <label htmlFor="progress-comments">Deliverable:</label>
                                <br />
                                <textarea
                                    id="progress-comments"
                                    name="comments"
                                    required
                                    value={progressForm.comments}
                                    onChange={handleProgressFormChange}
                                    className="form-input"
                                    style={{ minHeight: 60, resize: 'vertical', minWidth: 160 }}
                                    placeholder="Enter comments (mandatory)"
                                />
                            </div>
                            {progressForm.status === 'completed' && (
                                <div className="goal-detail-row">
                                    <label htmlFor="progress-file">Supporting Document:</label>
                                    <br />
                                    <input
                                        type="file"
                                        id="progress-file"
                                        name="file"
                                        required
                                        onChange={handleProgressFormChange}
                                        accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.webp"
                                        style={{ minHeight: 60, resize: 'vertical', minWidth: 160 }}
                                    />
                                </div>
                            )}
                            {progressSubmitError && <div className="error-state">{progressSubmitError}</div>}
                            <div className="modal-actions">
                                <button
                                    type="submit"
                                    className="submit-button"
                                    style={{ width: '100%' }}
                                    disabled={progressSubmitting || (progressForm.status === 'completed' && progressForm.score > selectedGoal.metric)}
                                >
                                    {progressSubmitting ? 'Updating...' : 'Submit'}
                                </button>
                                <button onClick={closeProgressModal} className="cancel-button">Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {/* Edit Goal Modal */}
            {editModalOpen && (
                <div className="modal-overlay" onClick={(e) => handleOverlayClick(e, closeEditModal)} style={{ backdropFilter: 'blur(8px)', background: 'rgba(15, 23, 42, 0.4)' }}>
                    <div className="modal-content-employee-goal" style={{
                        maxWidth: 650,
                        borderRadius: 24,
                        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                        overflowY: 'auto',
                        maxHeight: '90vh',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        background: '#ffffff'
                    }}>
                        <div className="modal-header" style={{
                            padding: '24px 32px',
                            borderBottom: '1px solid #f1f5f9',
                            background: '#ffffff',
                            borderTopLeftRadius: 24,
                            borderTopRightRadius: 24,
                            position: 'sticky',
                            top: 0,
                            zIndex: 10,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <div>
                                <h2 style={{ fontWeight: 800, fontSize: 26, color: '#0f172a', margin: 0, letterSpacing: '-0.02em' }}>Edit KPI Details</h2>
                                <p style={{ margin: '4px 0 0 0', color: '#64748b', fontSize: 14 }}>Refine your key performance indicator settings</p>
                            </div>
                        </div>
                        <form onSubmit={handleEditSubmit} className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 24, padding: '32px', background: '#fff', borderBottomLeftRadius: 24, borderBottomRightRadius: 24 }}>
                            <div className="goal-detail-row" style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '00%' }}>
                                <label style={{ fontWeight: 600, color: '#475569', fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.025em' }}>Year <span className="required" style={{ color: '#ef4444' }}>*</span></label>
                                <select
                                    name="year"
                                    value={editForm.year}
                                    onChange={handleEditFormChange}
                                    required
                                    className=""
                                    disabled={editLoading}
                                    style={{ borderRadius: 12, border: '1px solid #e2e8f0', fontSize: 16, padding: '10px 14px', height: 48, background: '#f8fafc', transition: 'border-color 0.2s' }}
                                >
                                    {[new Date().getFullYear(), new Date().getFullYear() + 1].map(y => (
                                        <option key={y} value={y}>{y}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="goal-detail-row" style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
                                <label style={{ fontWeight: 600, color: '#475569', fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.025em' }}>Period <span className="required" style={{ color: '#ef4444' }}>*</span></label>
                                <Select
                                    name="quarter"
                                    value={editForm.quarter}
                                    onChange={handleEditSelectChange}
                                    options={quarterOptions}
                                    placeholder="Select Period"
                                    classNamePrefix="react-select"
                                    isDisabled={editLoading}
                                    required
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            minHeight: 48,
                                            borderRadius: 12,
                                            borderColor: state.isFocused ? '#6366f1' : '#e2e8f0',
                                            boxShadow: state.isFocused ? '0 0 0 4px rgba(99, 102, 241, 0.1)' : 'none',
                                            fontSize: 16,
                                            width: '100%',
                                            background: '#f8fafc',
                                            '&:hover': { borderColor: '#cbd5e1' }
                                        }),
                                        menu: (base) => ({ ...base, borderRadius: 12, fontSize: 16, zIndex: 20, boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)' }),
                                    }}
                                />
                            </div>

                            {editForm.quarter?.value === 'Weekly' && (
                                <div style={{ animation: 'fadeInScale 0.3s ease-out', width: '100%' }}>
                                    <div className="goal-detail-row" style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
                                        <label style={{ fontWeight: 600, color: '#475569', fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.025em' }}>Week Number <span className="required" style={{ color: '#ef4444' }}>*</span></label>
                                        <input
                                            type="number"
                                            name="week"
                                            value={editForm.week}
                                            onChange={handleEditFormChange}
                                            required
                                            className="form-input"
                                            placeholder="Enter week number (1-52)"
                                            min="1"
                                            max="52"
                                            disabled={editLoading}
                                            style={{ borderRadius: 12, border: '1px solid #e2e8f0', fontSize: 16, padding: '12px 16px', width: '100%', background: '#f8fafc' }}
                                        />
                                    </div>
                                </div>
                            )}

                            {editForm.quarter?.value === 'Monthly' && (
                                <div style={{ animation: 'fadeInScale 0.3s ease-out', width: '100%' }}>
                                    <div className="goal-detail-row" style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
                                        <label style={{ fontWeight: 600, color: '#475569', fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.025em' }}>Month <span className="required" style={{ color: '#ef4444' }}>*</span></label>
                                        <Select
                                            name="month"
                                            value={editForm.month}
                                            onChange={handleEditSelectChange}
                                            options={monthOptions}
                                            placeholder="Select Month"
                                            classNamePrefix="react-select"
                                            isDisabled={editLoading}
                                            required
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    minHeight: 48,
                                                    borderRadius: 12,
                                                    borderColor: state.isFocused ? '#6366f1' : '#e2e8f0',
                                                    boxShadow: state.isFocused ? '0 0 0 4px rgba(99, 102, 241, 0.1)' : 'none',
                                                    fontSize: 16,
                                                    width: '100%',
                                                    background: '#f8fafc'
                                                }),
                                                menu: (base) => ({ ...base, borderRadius: 12, fontSize: 16, zIndex: 20 }),
                                            }}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="goal-detail-row" style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
                                <label style={{ fontWeight: 600, color: '#475569', fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.025em' }}>Key Result Area <span className="required" style={{ color: '#ef4444' }}>*</span></label>
                                <Select
                                    name="key_result_area"
                                    value={editForm.key_result_area}
                                    onChange={handleEditSelectChange}
                                    options={kraOptions}
                                    placeholder={fetchingKRAs ? 'Loading KRAs...' : 'Select Key Result Area'}
                                    classNamePrefix="react-select"
                                    isDisabled={editLoading || fetchingKRAs}
                                    required
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            minHeight: 48,
                                            borderRadius: 12,
                                            borderColor: state.isFocused ? '#6366f1' : '#e2e8f0',
                                            boxShadow: state.isFocused ? '0 0 0 4px rgba(99, 102, 241, 0.1)' : 'none',
                                            fontSize: 16,
                                            width: '100%',
                                            background: '#f8fafc'
                                        }),
                                        menu: (base) => ({ ...base, borderRadius: 12, fontSize: 16, zIndex: 20 }),
                                    }}
                                />
                            </div>

                            <div className="goal-detail-row" style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
                                <label style={{ fontWeight: 600, color: '#475569', fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.025em' }}>Activity / Task <span className="required" style={{ color: '#ef4444' }}>*</span></label>
                                <textarea
                                    name="activity"
                                    value={editForm.activity}
                                    onChange={handleEditFormChange}
                                    required
                                    className="form-input"
                                    placeholder="Describe the activity or task in detail..."
                                    rows={3}
                                    disabled={editLoading}
                                    style={{ borderRadius: 12, border: '1px solid #e2e8f0', fontSize: 16, padding: '14px 16px', width: '100%', resize: 'vertical', background: '#f8fafc', minHeight: 100 }}
                                />
                            </div>

                            <div className="goal-detail-row" style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
                                <label style={{ fontWeight: 600, color: '#475569', fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.025em' }}>Performance Standard <span className="required" style={{ color: '#ef4444' }}>*</span></label>
                                <Select
                                    name="performance_standard"
                                    value={editForm.performance_standard}
                                    onChange={handleEditSelectChange}
                                    options={performanceStandardOptions}
                                    placeholder="Select Standard"
                                    classNamePrefix="react-select"
                                    isDisabled={editLoading}
                                    required
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            minHeight: 48,
                                            borderRadius: 12,
                                            borderColor: state.isFocused ? '#6366f1' : '#e2e8f0',
                                            boxShadow: state.isFocused ? '0 0 0 4px rgba(99, 102, 241, 0.1)' : 'none',
                                            fontSize: 16,
                                            width: '100%',
                                            background: '#f8fafc'
                                        }),
                                        menu: (base) => ({ ...base, borderRadius: 12, fontSize: 16, zIndex: 20 }),
                                    }}
                                />
                            </div>

                            <div className="goal-detail-row" style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
                                <label style={{ fontWeight: 600, color: '#475569', fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.025em' }}>Metric <span className="required" style={{ color: '#ef4444' }}>*</span></label>
                                <input
                                    type="number"
                                    name="metric"
                                    value={editForm.metric}
                                    onChange={handleEditFormChange}
                                    required
                                    className="form-input"
                                    placeholder="Target Value"
                                    min="0"
                                    disabled={editLoading}
                                    style={{ borderRadius: 12, border: '1px solid #e2e8f0', fontSize: 16, padding: '12px 16px', width: '100%', background: '#f8fafc', height: 48 }}
                                />
                            </div>
                            <div className="goal-detail-row" style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
                                <label style={{ fontWeight: 600, color: '#475569', fontSize: 14, textTransform: 'uppercase', letterSpacing: '0.025em' }}>Stakeholder <span className="required" style={{ color: '#ef4444' }}>*</span></label>
                                <input
                                    type="text"
                                    name="stakeholder"
                                    value={editForm.stakeholder}
                                    onChange={handleEditFormChange}
                                    required
                                    className="form-input"
                                    placeholder="Primary Contact"
                                    disabled={editLoading}
                                    style={{ borderRadius: 12, border: '1px solid #e2e8f0', fontSize: 16, padding: '12px 16px', width: '100%', background: '#f8fafc', height: 48 }}
                                />
                            </div>

                            {editError && <div className="error-state" style={{ color: '#dc2626', fontSize: 14, background: '#fef2f2', padding: '12px 16px', borderRadius: 12, border: '1px solid #fee2e2', fontWeight: 500 }}>{editError}</div>}
                            <div className="modal-actions" style={{ marginTop: 8 }}>
                                <button
                                    type="submit"
                                    className="submit-button"
                                    style={{
                                        width: '100%',
                                        fontWeight: 700,
                                        fontSize: 16,
                                        borderRadius: 14,
                                        padding: '16px 0',
                                        background: editLoading ? '#94a3b8' : 'linear-gradient(135deg, #4f46e5 0%, #3730a3 100%)',
                                        color: '#fff',
                                        border: 'none',
                                        cursor: editLoading ? 'not-allowed' : 'pointer',
                                        boxShadow: editLoading ? 'none' : '0 10px 15px -3px rgba(79, 70, 229, 0.4)',
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        transform: 'translateY(0)'
                                    }}
                                    disabled={editLoading}
                                >
                                    {editLoading ? 'Updating...' : 'Save KPI Changes'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default HODGoals;
